import { gql } from "@apollo/client";

export const DELETE_NEWS_GENERATION_RECORD_MUTATION = gql`
  mutation DeleteNewsArticle($newsId: String!, $tenantId: String!) {
    deleteNewsArticle(newsId: $newsId, tenantId: $tenantId)
  }
`;
